import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData,
  type ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError,
  type ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse,
  resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost,
} from '../../generated';

export type ResendInviteMutationVariables =
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData['path'];

export type ResendInviteMutation = ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse;

export const useResendInviteMutation = <
  TError = ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError,
  TContext = unknown,
>(
  options?: Omit<
    UseMutationOptions<ResendInviteMutation, TError, ResendInviteMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<ResendInviteMutation, TError, ResendInviteMutationVariables, TContext>({
    mutationKey: ['ResendInvite'],
    mutationFn: async ({ organization_id, user_id }: ResendInviteMutationVariables) => {
      const { data } = await resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost({
        path: { organization_id, user_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useResendInviteMutation.fetcher = (
  { organization_id, user_id }: ResendInviteMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost({
      path: { organization_id, user_id },
      throwOnError: true,
    });
    return data;
  };
};
